import { render } from "./ViewContact.vue?vue&type=template&id=2531662c&scoped=true"
import script from "./ViewContact.vue?vue&type=script&lang=js"
export * from "./ViewContact.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./ViewContact.vue?vue&type=style&index=1&id=2531662c&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2531662c"]])

export default __exports__